<script>
import SmallAnnouncementApi from "@/services/small-announcements-api";
import { Carousel, Slide } from 'vue-carousel';
import sharedDocumentsApi from "@/services/sharedDocuments-api";

export default {
    comments:{Carousel, Slide},
  data() {
    return {
      isExpanded: false,
      showSeeMore: false,
      alertList: [],
      showAlerts: false,

      overflowStates: {}
    };
  },
  mounted() {
    this.findAlerts();
   this.updateSeeMore();
  },

  updated() {
    this.updateSeeMore();
    },

  computed:{
     alertTitleList(){
        return this.alertList.map((alert) => alert.title);
     },

     // VUE_APP_FEATURE_NEWS_BAR_MARQUEE: a title too long for the bar scrolls on one line instead of wrapping
     marqueeEnabled(){
      return process.env.VUE_APP_FEATURE_NEWS_BAR_MARQUEE === 'true';
     },
     // the carousel must not move on while a long title is still scrolling
     carouselTimeout(){
      if (!this.marqueeEnabled) return 10000;
      const running = this.filteredAlertList.filter(a => this.overflowStates[a.id]).map(a => this.marqueeSeconds(a));
      return Math.max(10000, ...running.map(x => x * 1000));
     },
     isShowIconInNews(){
      return process.env.VUE_APP_FEATURE_NEWS_SLIDING_BAR_SHOW_ICON === 'true';
    },

    isSharedDocumentsEnabled() {
      return process.env.VUE_APP_FEATURE_SHARED_DOCUMENTS === 'true';
    },

    filteredAlertList() {
      if (this.isSharedDocumentsEnabled) {
        return this.alertList;
      }
      return this.alertList.filter(alert => !alert.sharedDocumentFileName);
    }
  },
  methods: {
      marqueeSeconds(alert) {
          return Math.round(8 + (alert.title || '').length * 0.12);
      },
      downloadSharedDocument(fileName) {
          sharedDocumentsApi.downloadSharedDocument(fileName)
      },

    findAlerts() {
      SmallAnnouncementApi.findAllAlert().then((result) => {
        if (result) {
          this.alertList = result;
          this.showAlerts = this.alertList && this.alertList.length
        }
      });
    },

    toggleExpand() {
        
        this.isExpanded = !this.isExpanded;
    },

    async updateSeeMore() {
    await this.$nextTick();

    const results = await Promise.all(this.alertList.map(async (alert) => {
      const result = await this.checkOverflow(alert.id);
      return { id: alert.id, result };
    }));

    // Update overflowStates with the results
    results.forEach(({ id, result }) => {
      this.$set(this.overflowStates, id, result);
    });
  },
  
  // Simulated async function for checking overflow
  checkOverflow(alertId) {
    return new Promise((resolve) => {
        const element= document.getElementById('textContainer' + alertId)
        if (!element) {
            resolve(false);
            return;
        }
        // marquee: the text span is inline-block, its box is the full text; compare with the bar it sits in
        const result= this.marqueeEnabled
            ? element.scrollWidth > element.parentElement.clientWidth
            : element.scrollWidth > element.clientWidth;
      resolve(result);
    });
  }

  },
};
</script>

<template>
    

        <carousel  :per-page="1" :autoplay="true" :loop="true" :scrollPerPage="false" :paginationEnabled="false" :speed="2000" :autoplayTimeout="carouselTimeout"  :centerMode="true" :mouse-drag="true" >
            <slide   v-for="alert in filteredAlertList" :key="alert.id" :data-index="alert.id" :data-name="alert.title" style="width:100%; text-align: center; " :style=" alert.isNewAnnouncement ? 'background-color: #d90100 !important;' :  'background-color: #00afc9 !important;'" class="pt-1 pb-1"  >
                <div class="text-container text-center h-100 pr-4 pl-4"  >
                  
                  <img v-if="alert.isNewAnnouncement && isShowIconInNews" src="@/assets/images/new.png" alt height="50" />

                  
                  <div v-if="marqueeEnabled" class="nb-marquee">
                    <span :id="'textContainer' + alert.id"
                          class="nb-marquee__text text-uppercase font-size-14"
                          :class="{ 'is-running': overflowStates[alert.id] }"
                          :style="[{ animationDuration: marqueeSeconds(alert) + 's' }, alert.sharedDocumentFileName ? { cursor: 'pointer' } : {}]"
                          @click="alert.sharedDocumentFileName ? downloadSharedDocument(alert.sharedDocumentFileName) : null">
                      <span class="mr-2" style="color: rgb(255, 214, 112) !important;" v-if="alert.sharedDocumentFileName"><span> Cliquer ici </span> pour découvrir :  </span>
                      {{alert.title}}
                    </span>
                  </div>
                  <span v-else :id="'textContainer' + alert.id"
                        :class="{ 'text-truncated':!isExpanded }"
                        class="text-uppercase font-size-14 text-center"
                        style="letter-spacing: 0.2px;margin:auto;"
                        :style="alert.sharedDocumentFileName ? 'cursor: pointer;' : 'cursor: normal;'"
                        @click="alert.sharedDocumentFileName ? downloadSharedDocument(alert.sharedDocumentFileName) : null">
                        
                        
                          <span class="mr-2"  style="color: rgb(255, 214, 112) !important;" v-if="alert.sharedDocumentFileName"><span> Cliquer ici </span> pour découvrir :  </span>
                          {{alert.title}} 

                    </span>

                </div>
               
            </slide>
        </carousel>
    
    
  </template>
  

<style scoped>

.text-container {
  display: flex ;
  align-items: center;
}

.text-truncated {
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nb-marquee {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}
.nb-marquee__text {
  display: inline-block;
  white-space: nowrap;
  letter-spacing: 0.2px;
}
/* starts just off the right edge (padding = the bar width), ends fully off the left edge */
.nb-marquee__text.is-running {
  padding-left: 100%;
  animation-name: nb-marquee-scroll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.nb-marquee:hover .nb-marquee__text.is-running {
  animation-play-state: paused;
}
@keyframes nb-marquee-scroll {
  from { transform: translateX(0); }
  to   { transform: translateX(-100%); }
}

.toggle-icon {
  margin-left: 5px;
  color: #007bff;
  cursor: pointer;
  text-decoration: none;
}

.toggle-icon i {
  font-size: 12px;
}

</style>